export default {
  "confirmBookingView.agency": "Agency",
  "confirmBookingView.discount": "Discount",
  "confirmBookingView.subtotal": "Subtotal",
  "confirmBookingView.total": "Total",
};
